export const COTACAO_PRODUTO = () => `/cotacao-produtos`;
